import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider, theme as antdTheme } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { AuthProvider } from './contexts/AuthContext';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ConfigProvider
          locale={zhCN}
          theme={{
            algorithm: antdTheme.defaultAlgorithm,
            token: {
              colorPrimary: '#0A4A5E', // 深藍主色（#1E88A8 同色系深版）
              colorInfo: '#1E88A8',
              colorSuccess: '#16A34A',
              colorWarning: '#D97706',
              colorError: '#DC2626',
              colorBgLayout: '#F5F7FB',
              colorText: '#1F2937',
              colorBorder: '#E5E7EB',
              borderRadius: 8,
              fontFamily:
                "Inter, 'Noto Sans TC', 'Microsoft JhengHei', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
            },
          }}
        >
          <App />
        </ConfigProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
